const serverApi =
{ 
    url : 'https://apicondutorlegal.azurewebsites.net',
    //urlPHP : 'https://apicondutorlegal.azurewebsites.net/apicdl',
    urlPHP : 'https://apiphpcl.condutorlegal.com.br/ecommerce-app-api/apicdl',
    // urlPHP: 'http://localhost:8081/apicdl',
    //url : 'https://api.labet.com.br/CondutorLegalAPI',
    //urlPHP : 'https://wscl.labest.com.br',
    //url : 'https://apicdlrelease.azurewebsites.net',
    //url : 'http://localhost/GT.Api',
    urlAPIConsultas: 'https://api-consultas.azurewebsites.net',
    versao : '/api/appUsuario/v1' 
}


export {serverApi}